import HeaderComponent from "components/card/HeaderComponent";
import { LucideClipboardCheck } from "lucide-react";
import { connect } from "react-redux";
import WorkSummaryCard from "./components/WorkSummaryCard";
import WorkStatusGrid from "./components/WorkStatusGrid";
import MonthlyWorkHoursGraph from "./components/MonthlyWorkHoursGraph";
import RecentAttendanceList from "./components/RecentAttendanceList";


const EmployeeAttendance = () => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-6 rounded-xl border-2 border-blue-200 dark:border-blue-700 bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-950/30 dark:to-cyan-950/30 p-4">
        <div className="flex items-center gap-3">
          <span className="p-3 rounded-full bg-blue-100 dark:bg-blue-900/50 text-blue-600"><LucideClipboardCheck/></span>
          <div>
            <h3 className="text-sm font-semibold">Standard Working Hours</h3>
            <p className="text-xs text-slate-700">7:00 AM - 4:00 PM (9 hours total, including 1 hour lunch break)</p>
          </div>
        </div>
      </div>
      <WorkSummaryCard/>
      <HeaderComponent
        title="Detailed Attendance Breakdown"
        labelIcon={<LucideClipboardCheck size={20}/>}
        description="Comprehensive view of your attendance and work hours"
        bgcolor="border-b bg-slate-50"
        >
          <div className="space-y-5">
            <WorkStatusGrid/>
            <MonthlyWorkHoursGraph/>
            <RecentAttendanceList/>
          </div>

      </HeaderComponent>
    </div>

  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeAttendance);
